var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#F2F4F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#001B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeft);
export default __webpack_public_path__ + "static/media/bottomLeft.6d5d7d25a2c35fbbb8852e8874d4ddd2.svg";
export { ForwardRef as ReactComponent };